import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

import { OrganizationUnit } from './types';

export const useAllOrgUnits = (): {
  orgUnits: OrganizationUnit[];
  orgUnitsIncludeDeleted: OrganizationUnit[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });
};
